// <editor-fold desc="Action Types">

/**
 * Action Types
 */
export enum ActionTypes {
  /**
   * Store
   */
  GetUsersSuccess = '[STORE | SHARED | USER] Get Users Success',
  GetUsers = '[STORE | SHARED | USER] Get Users',
  /**
   * Request
   */
  GetUsersRequest = '[REQUEST | SHARED | USER] Get Users Request',
  GetUserRequest = '[REQUEST | SHARED | USER] Get User Request'
}

// </editor-fold>

// <editor-fold desc="Models">

// </editor-fold>

// <editor-fold desc="Store">

/**
 * Get Users Success
 */
export class GetUsersSuccess {
  public static readonly type = ActionTypes.GetUsersSuccess;
}

/**
 * Get Users
 */
export class GetUsers {
  public static readonly type = ActionTypes.GetUsers;
}

// </editor-fold>

// <editor-fold desc="Request">

/**
 * Get Users Request
 */
export class GetUsersRequest {
  public static readonly type = ActionTypes.GetUsersRequest;
}

/**
 * Get User
 */
export class GetUserRequest {
  public static readonly type = ActionTypes.GetUserRequest;

  public constructor(public id: string) {
  }
}

// </editor-fold>
